import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiMapPin, FiBook, FiClock, FiCheckCircle, FiPhone, FiMessageCircle } = FiIcons;

const TutorProfileModal = ({ tutor, onClose }) => {
  if (!tutor) return null;
  const subjectDisplay = Array.isArray(tutor.subjects) ? tutor.subjects.join(', ') : tutor.subjects;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      <div
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <div className="h-1.5 bg-gradient-to-r from-primary to-orange-400" />
        <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition">
          <FiX className="w-4 h-4 text-gray-600" />
        </button>
        <div className="p-6 pb-4 flex gap-4 items-center border-b border-gray-100">
          <div className="relative flex-shrink-0">
            <img src={tutor.img} alt={tutor.name} className="w-20 h-20 rounded-2xl object-cover border-2 border-red-100 shadow" />
            {tutor.verified && (
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center border-2 border-white">
                <FiCheckCircle className="text-white w-3.5 h-3.5 fill-current" />
              </div>
            )}
          </div>
          <div>
            <h3 className="text-xl font-extrabold text-slate-900">{tutor.name}</h3>
            <p className="text-xs text-gray-500 font-semibold mt-0.5">{tutor.qualifications}</p>
            <span className="inline-block mt-1.5 text-xs bg-blue-50 text-blue-600 font-bold px-2 py-0.5 rounded-full">{tutor.exp}</span>
          </div>
        </div>
        <div className="p-6 space-y-4">
          <InfoRow icon={FiBook} label="Subjects" value={subjectDisplay} />
          <InfoRow icon={FiClock} label="Experience" value={tutor.exp} />
          <InfoRow icon={FiMapPin} label="Serving Location" value={tutor.locations.join(', ')} />
        </div>
        <div className="px-6 pb-6 flex gap-3">
          <a
            href="tel:+919415905584"
            className="flex-1 flex items-center justify-center gap-2 bg-primary text-white py-3.5 rounded-xl font-extrabold hover:bg-primary-hover transition shadow-lg tracking-wide text-sm"
          >
            <FiPhone className="w-4 h-4" />
            Call
          </a>
          <a
            href="https://wa.me/919415905584"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-green-500 text-white py-3.5 rounded-xl font-extrabold hover:bg-green-600 transition shadow-lg tracking-wide text-sm"
          >
            <FiMessageCircle className="w-4 h-4" />
            Chat
          </a>
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3">
    <div className="w-9 h-9 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
      <Icon className="w-4 h-4 text-primary" />
    </div>
    <div>
      <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">{label}</p>
      <p className="text-sm font-bold text-slate-800 mt-0.5">{value}</p>
    </div>
  </div>
);

export default TutorProfileModal;